import { render, staticRenderFns } from "./onboarding.vue?vue&type=template&id=341369c4&"
import script from "./onboarding.vue?vue&type=script&lang=js&"
export * from "./onboarding.vue?vue&type=script&lang=js&"
import style0 from "./onboarding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports